import { render, staticRenderFns } from "./NuevoSocketVideo.vue?vue&type=template&id=ca7ccf9e&scoped=true&"
import script from "./NuevoSocketVideo.vue?vue&type=script&lang=js&"
export * from "./NuevoSocketVideo.vue?vue&type=script&lang=js&"
import style0 from "./NuevoSocketVideo.vue?vue&type=style&index=0&id=ca7ccf9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7ccf9e",
  null
  
)

export default component.exports